import { Ternary } from '@/components';
import { Checkbox, CheckboxProps, Space, Tag, Typography } from 'antd';
import React, { FC } from 'react';
import { useTab } from '../../../../../stores/useTab';
const preventDefault = (e: React.MouseEvent<HTMLSpanElement>) =>
  e.preventDefault();

/**
 * 指定区域抽取
 * @description
 * value 字段是 checked;
 * 0.不开启 1.开启;
 */
export const AreaExtractionCheckbox: FC<
  Omit<CheckboxProps, 'onChange' | 'checked'> & {
    onChange?: (checked: number) => void;
    checked?: number;
    showRedirect?: boolean;
    onRedirect?: () => void;
    /**
     * 0.未指定 1.已经指定;
     */
    status: 0 | 1;
  }
> = ({
  onChange,
  checked,
  onRedirect,
  status,
  showRedirect = true,
  ...props
}) => {
  const _checked = checked === 1;
  const _onChange: CheckboxProps['onChange'] = (e) => {
    let newValue = e.target.checked ? 1 : 0;
    onChange?.(newValue);
  };

  return (
    <div>
      <Checkbox {...props} onChange={_onChange} checked={_checked}>
        <Space>
          在页面指定区域抽取
          <Ternary condition={Boolean(checked)} falseElement={null}>
            <Ternary
              condition={Boolean(status === 0)}
              falseElement={
                <Tag color="green" onClick={preventDefault}>
                  已指定
                </Tag>
              }
            >
              <Tag color="red" onClick={preventDefault}>
                未指定
              </Tag>
            </Ternary>
            <Typography.Link
              hidden={!showRedirect}
              onClick={(e) => {
                preventDefault(e);
                onRedirect?.();
              }}
            >
              去配置
            </Typography.Link>
          </Ternary>
        </Space>
      </Checkbox>
    </div>
  );
};
